import { setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

/**
 * Points MapLibre at a worker Vite has bundled. MapLibre v6 finds its worker with
 * `new URL('./maplibre-gl-worker.mjs', import.meta.url)` built from a variable, which
 * Vite can't see, so the file never reaches the build and the request falls through
 * to the SPA's index.html. Call before creating any map; repeat calls are harmless.
 */
export function configureMapLibreWorker(): void {
  setWorkerUrl(workerUrl);
}
